export default __webpack_public_path__ + "static/media/bathroom-cleaning.0e599786.jpeg";